import { useListProposalsQuery } from '~/api/endpoints/proposals'

/**
 * The pending queue, as the Approvals page and the nav badge both ask for it: same
 * arguments, so one cache entry and one request between them; a modest poll, and a
 * refetch when the tab comes back.
 */
export function usePendingProposals() {
  return useListProposalsQuery(
    { status: 'pending' },
    { pollingInterval: 60_000, refetchOnFocus: true },
  )
}
